import BaseModal from "../../components/BaseModal";
import LikeButton from "../../components/LikeButton";
import { ModalInterface } from "../../interfaces/ModalInterface";
import { OpeningWarehouseProduct } from "../../interfaces/OpeningWarehouseProduct";

interface ExModalInterface extends ModalInterface<OpeningWarehouseProduct> {
  handleLikeClick: (row: OpeningWarehouseProduct) => OpeningWarehouseProduct;
}

export default function ProductModal(props: ExModalInterface) {
  const { modal, handleLikeClick, setModal } = props;

  const handleModalLikeClick = (row: OpeningWarehouseProduct | undefined) => {
    if (row) {
      const newRow = handleLikeClick(row);
      setModal(true, newRow);
    }
  };

  return modal.selected ? (
    <BaseModal modal={modal} setModal={setModal}>
      <div className="justify-self-center">
        <LikeButton
          onClick={() => handleModalLikeClick(modal.selected)}
          isLike={modal.selected.isLike}
        ></LikeButton>
      </div>
    </BaseModal>
  ) : (
    <></>
  );
}
